/** token 변화에 따른 렌더링을 위해 AccessToken 값과 token 을 변화시킬 수 있는 함수를 Context 로 분리 **/
/** App.js와 API 를 제외한 일반 컴포넌트에서는 token Read, Update 를 위해 Context 만 사용한다. (Token.js 직접 사용 안함) **/
import React from 'react';

export const UserContext = React.createContext({
  accessToken: '',
  setToken: () => {},
});